import React, { FunctionComponent } from 'react'

import { Box, Flex } from '../atoms'
import { OptionTile } from './OptionTile'

export interface BooleanInputProps {
  name: string
  value: boolean | undefined
  onSelect: (value: boolean) => void

  trueLabel?: string
  falseLabel?: string
  ariaLabelledBy?: string
}

export const BooleanInput: FunctionComponent<BooleanInputProps> = ({
  name,
  value,
  onSelect,

  trueLabel = 'Yes',
  falseLabel = 'No',
  ariaLabelledBy,
}) => (
  <Flex
    flexDirection='row'
    width={['100%', '100%', 'fit-content']}
    minWidth={[null, null, '80%', '60%']}
    maxWidth='100%'
    gap={3}
    role='radiogroup'
    aria-labelledby={ariaLabelledBy}
  >
    <Box width={1}>
      <OptionTile
        name={name}
        value={true}
        text={trueLabel}
        onSelect={onSelect}
        checked={value === true}
      />
    </Box>
    <Box width={1}>
      <OptionTile
        name={name}
        value={false}
        text={falseLabel}
        onSelect={onSelect}
        checked={value === false}
      />
    </Box>
  </Flex>
)
